module.exports = __webpack_public_path__ + "assets/img/season-code-05-db7e184f.png";